import { render, staticRenderFns } from "./LessonHeader.vue?vue&type=template&id=4c1adade"
import script from "./LessonHeader.vue?vue&type=script&lang=js"
export * from "./LessonHeader.vue?vue&type=script&lang=js"
import style0 from "./LessonHeader.vue?vue&type=style&index=0&id=4c1adade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports